import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  MatchupDataContainer, type MatchupDataContainerProps,
} from './matchupData.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MatchupData: MatchupDataContainerProps;
  }
}

modalRenderer.register('MatchupData', MatchupDataContainer);
